import { action, createRequestTypes } from './base';

export const purchaseOrderActionTypes = {
  GET_PURCHASE_ORDERS: createRequestTypes('GET_PURCHASE_ORDERS'),
  CREATE_PURCHASE_ORDER: createRequestTypes('CREATE_PURCHASE_ORDER'),
  UPDATE_PURCHASE_ORDER: createRequestTypes('UPDATE_PURCHASE_ORDER'),
  DELETE_PURCHASE_ORDER: createRequestTypes('DELETE_PURCHASE_ORDER'),
  GET_DOWNLOAD_PURCHASE_ORDER_DATA: createRequestTypes('GET_DOWNLOAD_PURCHASE_ORDER_DATA'),
  GET_PURCHASE_ORDER_BY_ID: createRequestTypes('GET_PURCHASE_ORDER_BY_ID'),
  UPDATE_PO_STATUS: createRequestTypes('UPDATE_PO_STATUS'),
  UPDATE_PO_WORKFLOW_STEP: createRequestTypes('UPDATE_PO_WORKFLOW_STEP'),
  GET_PO_ANALYTICS: createRequestTypes('GET_PO_ANALYTICS'),
  APPROVE_PO: createRequestTypes('APPROVE_PO'),
  GET_PO_PENDING_APPROVAL: createRequestTypes('GET_PO_PENDING_APPROVAL'),
  GET_PO_SEQUENCE: createRequestTypes('GET_PO_SEQUENCE'),
  UPDATE_PO_SEQUENCE: createRequestTypes('UPDATE_PO_SEQUENCE'),
  SEND_PO_EMAIL_TO_VENDOR: createRequestTypes('SEND_PO_EMAIL_TO_VENDOR'),
  UPDATE_PO_EXPIRY_DATE: createRequestTypes('UPDATE_PO_EXPIRY_DATE'),
  CLOSE_PO: createRequestTypes('CLOSE_PO'),
  SEND_PO_WHATSAPP: createRequestTypes('SEND_PO_WHATSAPP'),
};

/**
 * @param payload
 * @param getPoPendingApprovalLoading
 * @param tenantId
 * @param sendPOMailToVendorLoading
 * @param callback
 */
class PurchaseOrderActions {
  /**
   * @param {*} orgId
   * @param {*} tenantId
   * @param {*} tenantSellerId
   * @param {*} poId
   * @param {*} onDate
   * @param {*} fromDate
   * @param {*} toDate
   * @param {*} status
   * @param {*} poReceivingStatus
   * @param {*} expiryStartDate
   * @param {*} expiryEndDate
   * @param {*} page
   * @param {*} limit
   * @param roleId
   * @param callback
   * @param poNumber
   * @param searchKeyword
   * @return
   */
  downloadPOData = (payload, callback) => action(purchaseOrderActionTypes.GET_DOWNLOAD_PURCHASE_ORDER_DATA.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param {*} getDownloadPOLoading
   * @return
   */
  getDownloadPODataLoading = (getDownloadPOLoading) => action(purchaseOrderActionTypes.GET_DOWNLOAD_PURCHASE_ORDER_DATA.LOADING, {
    getDownloadPOLoading,
  })

  /**
   *
   * @param {*} downloadPOData
   * @return
   */
  getDownloadPODataSuccess = (downloadPOData) => action(purchaseOrderActionTypes.GET_DOWNLOAD_PURCHASE_ORDER_DATA.SUCCESS, {
    downloadPOData,
  })

  /**
    * @param {*} orgId
    * @param {*} tenantId
    * @param {*} tenantSellerId
    * @param {*} poId
    * @param {*} onDate
    * @param {*} fromDate
    * @param {*} toDate
    * @param {*} status
    * @param {*} poReceivingStatus
    * @param {*} expiryStartDate
    * @param {*} expiryEndDate
    * @param {*} page
    * @param {*} limit
    * @param roleId
    * @param callback
    * @param poNumber
    * @param searchKeyword
    * @return
    */
  getPurchaseOrders = (orgId, tenantId, tenantSellerId, poId, onDate, fromDate, toDate, status, page, limit, roleId, callback, poNumber, searchKeyword, poReceivingStatus, expiryStartDate, expiryEndDate, paymentStatus, edd, productSearch, mrpId, tags, departmentIds, excludeMrpLinked, destinationTenantId, isListScreen, excludeJobWorksPo, excludeSubcontractorPo, linkedPoIds) => action(purchaseOrderActionTypes.GET_PURCHASE_ORDERS.REQUEST, {
    orgId, tenantId, tenantSellerId, poId, onDate, fromDate, toDate, status, page, limit, roleId, callback, poNumber, searchKeyword, poReceivingStatus, expiryStartDate, expiryEndDate, paymentStatus, edd, productSearch, mrpId, tags, departmentIds, excludeMrpLinked, destinationTenantId, isListScreen, excludeJobWorksPo, excludeSubcontractorPo, linkedPoIds
  })

  /**
   *
   * @param getPurchaseOrdersLoading
   * @return {{type: *}}
   */
  getPurchaseOrdersLoading = (getPurchaseOrdersLoading) => action(purchaseOrderActionTypes.GET_PURCHASE_ORDERS.LOADING, {
    getPurchaseOrdersLoading,
  })

  /**
   * @param purchaseOrders
   * @param orgPos
   * @return {{type: *}}
   */
  getPurchaseOrdersSuccess = (purchaseOrders) => action(purchaseOrderActionTypes.GET_PURCHASE_ORDERS.SUCCESS, {
    purchaseOrders,
  })

  /**
   * @param payload
   * @param callback
   * @param withApproval
   * @return {{type: *}}
   */
  createPurchaseOrder = (payload, callback, withApproval) => action(purchaseOrderActionTypes.CREATE_PURCHASE_ORDER.REQUEST, {
    payload,
    callback,
    withApproval,
  })

  /**
   * @param createPurchaseOrderLoading
   * @param addCustomPurchaseOrderLoading
   * @return {{type: *}}
   */
  createPurchaseOrderLoading = (createPurchaseOrderLoading) => action(purchaseOrderActionTypes.CREATE_PURCHASE_ORDER.LOADING, {
    createPurchaseOrderLoading,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  approvePO = (payload, callback) => action(purchaseOrderActionTypes.APPROVE_PO.REQUEST, {
    payload,
    callback,
  })

  /**
   * @param {*} approvePOLoading
   * @param po_type
   * @param poType
   * @param type
   * @return
   */
  approvePOLoading = (approvePOLoading, poType) => action(purchaseOrderActionTypes.APPROVE_PO.LOADING, {
    approvePOLoading,
    poType,
  })

  /**
   * @param {*} payload
   * @param {*} callback
   * @param withApproval
   * @param updatePurchaseOrder
   * @return
   */
  updatePurchaseOrder = (payload, callback, withApproval) => action(purchaseOrderActionTypes.UPDATE_PURCHASE_ORDER.REQUEST, {
    payload,
    callback,
    withApproval,
  })

  /**
   *
   * @param updatePurchaseOrderLoading
   * @return {{type: *}}
   */
  updatePurchaseOrderLoading = (updatePurchaseOrderLoading) => action(purchaseOrderActionTypes.UPDATE_PURCHASE_ORDER.LOADING, {
    updatePurchaseOrderLoading,
  })

  /**
   * @param {*} payload
   * @param {*} callback
   * @param updatePurchaseOrder
   * @return
   */
  updatePurchaseOrderExpiryDate = (payload, callback) => action(purchaseOrderActionTypes.UPDATE_PO_EXPIRY_DATE.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param updatePurchaseOrderExpiryDateLoading
   * @return {{type: *}}
   */
  updatePurchaseOrderExpiryDateLoading = (updatePurchaseOrderExpiryDateLoading) => action(purchaseOrderActionTypes.UPDATE_PO_EXPIRY_DATE.LOADING, {
    updatePurchaseOrderExpiryDateLoading,
  })

  /**
   *
   * @param {*} startDate
   * @param {*} endDate
   * @param {*} tenantId
   * @param {*} sellerId
   * @param {*} orgId
   * @return
   */
  getPOAnalytics = (startDate, endDate, tenantId, sellerId, orgId) => action(purchaseOrderActionTypes.GET_PO_ANALYTICS.REQUEST, {
    startDate, endDate, tenantId, sellerId, orgId,
  })

  /**
   *
   * @param {*} getPOAnalyticsLoading
   * @return
   */
  getPOAnalyticsLoading = (getPOAnalyticsLoading) => action(purchaseOrderActionTypes.GET_PO_ANALYTICS.LOADING, {
    getPOAnalyticsLoading,
  })

  /**
   * @return
   * @param purchaseAnalyticsData
   */
  getPOAnalyticsSuccess = (purchaseAnalyticsData) => action(purchaseOrderActionTypes.GET_PO_ANALYTICS.SUCCESS, {
    purchaseAnalyticsData,
  })

  /**
   *
   * @return {{type: *}}
   */
  getPoPendingApproval = () => action(purchaseOrderActionTypes.GET_PO_PENDING_APPROVAL.REQUEST, {});

  /**
   *
   * @param getPoPendingApprovalLoading
   * @return {{type: *}}
   */
  getPoPendingApprovalLoading = (getPoPendingApprovalLoading) => action(purchaseOrderActionTypes.GET_PO_PENDING_APPROVAL.LOADING, {
    getPoPendingApprovalLoading,
  })

  /**
   *
   * @param pendingPos
   * @return {{type: *}}
   */
  getPoPendingApprovalSuccess = (pendingPos) => action(purchaseOrderActionTypes.GET_PO_PENDING_APPROVAL.SUCCESS, {
    pendingPos,
  })

  /**
   * @param poId
   * @param tenantId
   * @param callback
   * @return {{type: *}}
   */
  getPurchaseOrderById = (poId, tenantId, callback) => action(purchaseOrderActionTypes.GET_PURCHASE_ORDER_BY_ID.REQUEST, {
    poId,
    tenantId,
    callback,
  })

  /**
   * @param getPurchaseOrderByIdLoading
   * @return {{type: *}}
   */
  getPurchaseOrderByIdLoading = (getPurchaseOrderByIdLoading) => action(purchaseOrderActionTypes.GET_PURCHASE_ORDER_BY_ID.LOADING, {
    getPurchaseOrderByIdLoading,
  })

  /**
   * @param selectedPurchaseOrder
   * @param selectedPo
   * @return {{type: *}}
   */
  getPurchaseOrderByIdSuccess = (selectedPurchaseOrder) => action(purchaseOrderActionTypes.GET_PURCHASE_ORDER_BY_ID.SUCCESS, {
    selectedPurchaseOrder,
  })

  /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updatePoStatus = (payload, callback) => action(purchaseOrderActionTypes.UPDATE_PO_STATUS.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param updatePoStatusLoading
   * @return {{type: *}}
   */
  updatePoStatusLoading = (updatePoStatusLoading) => action(purchaseOrderActionTypes.UPDATE_PO_STATUS.LOADING, {
    updatePoStatusLoading,
  })

  /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updatePoWorkflowStep = (payload, callback) => action(purchaseOrderActionTypes.UPDATE_PO_WORKFLOW_STEP.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param updatePoWorkflowStepLoading
   * @return {{type: *}}
   */
  updatePoWorkflowStepLoading = (updatePoWorkflowStepLoading) => action(purchaseOrderActionTypes.UPDATE_PO_WORKFLOW_STEP.LOADING, {
    updatePoWorkflowStepLoading,
  })

  /**
   *
   * @param tenantId
   * @return {{type: *}}
   */
  getPoSequence = (tenantId, callback) => action(purchaseOrderActionTypes.GET_PO_SEQUENCE.REQUEST, {
    tenantId, callback,
  })

  /**
   *
   * @param getPoSequenceLoading
   * @return {{type: *}}
   */
  getPoSequenceLoading = (getPoSequenceLoading) => action(purchaseOrderActionTypes.GET_PO_SEQUENCE.LOADING, {
    getPoSequenceLoading,
  })

  /**
   *
   * @param poSequence
   * @return {{type: *}}
   */
  getPoSequenceSuccess = (poSequence) => action(purchaseOrderActionTypes.GET_PO_SEQUENCE.SUCCESS, {
    poSequence,
  })

  /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updatePoSequence = (payload, callback) => action(purchaseOrderActionTypes.UPDATE_PO_SEQUENCE.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param updatePoSequenceLoading
   * @return {{type: *}}
   */
  updatePoSequenceLoading = (updatePoSequenceLoading) => action(purchaseOrderActionTypes.UPDATE_PO_SEQUENCE.LOADING, {
    updatePoSequenceLoading,
  })

  /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  deletePurchaseOrder = (payload, callback) => action(purchaseOrderActionTypes.DELETE_PURCHASE_ORDER.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param deletePurchaseOrderLoading
   * @return {{type: *}}
   */
  deletePurchaseOrderLoading = (deletePurchaseOrderLoading) => action(purchaseOrderActionTypes.DELETE_PURCHASE_ORDER.LOADING, {
    deletePurchaseOrderLoading,
  })

  /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  sendPOMailToVendor = (payload, callback) => action(purchaseOrderActionTypes.SEND_PO_EMAIL_TO_VENDOR.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param sendPOMailToVendorLoading
   * @return {{type: *}}
   */
  sendPOMailToVendorLoading = (sendPOMailToVendorLoading) => action(purchaseOrderActionTypes.SEND_PO_EMAIL_TO_VENDOR.LOADING, {
    sendPOMailToVendorLoading,
  })

  closePo = (payload, callback) => action(purchaseOrderActionTypes.CLOSE_PO.REQUEST, {
    payload, callback,
  })

  closePoLoading = (closePoLoading) => action(purchaseOrderActionTypes.CLOSE_PO.LOADING, {
    closePoLoading,
  })

  sendPoWhatsapp = (payload, callback) => action(purchaseOrderActionTypes.SEND_PO_WHATSAPP.REQUEST, {
    payload, callback,
  })

  sendPoWhatsappLoading = (sendPoWhatsappLoading) => action(purchaseOrderActionTypes.SEND_PO_WHATSAPP.LOADING, {
    sendPoWhatsappLoading,
  })
}

export default new PurchaseOrderActions();
